import fetch from "node-fetch";
import {useEffect, useState} from "react";
import {API_ENDPOINTS } from "../../config";
import { ChevronLeftIcon, ChevronRightIcon, ArrowRightCircleIcon } from '@heroicons/react/20/solid';
import SingleRefView from "./SingleRefView";
import {use} from "bcrypt/promises";
import GoogleMapComponent from "../../googleMap/googleMap";

const AllRefListView = () => {

    const [allRefImages, SetAllRefImages] = useState([]);
    const [filteredRefs, SetFilteredRefs] = useState([]);

    const [loading, setLoading] = useState(false);
    const [showImages, setShowImages] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [refsPerPage] = useState(10);

    const [searchValue, SetSearchValue] = useState('');


    useEffect(() => {
        FetchAllReferences();
    }, []);

    const FetchAllReferences = async () => {
        const token = localStorage.getItem('token');
        
        await fetch(API_ENDPOINTS.getAllReferences, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`

            },
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Error: ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => {
                console.log("All Images fetched ", data);
                SetAllRefImages(data.items);
                SetFilteredRefs(data.items);
            })
            .catch(error => {
                console.error('Failed to fetch jobs:', error);
            })
        console.log("Ending Fetch");
    }

    const handleDelete = async (id) => {
        const token = localStorage.getItem('token');

        setLoading(true);
        const url = `${API_ENDPOINTS.deleteSingleReference}/${id}`;
        console.log("HandleDelete with url => ", url)
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });

        if (response.ok) {
            await FetchAllReferences();
        }

        setLoading(false);
    }

    const indexOfLastRef = currentPage * refsPerPage;
    const indexOfFirstRef = indexOfLastRef - refsPerPage;
    const currentRefs = filteredRefs.slice(indexOfFirstRef, indexOfLastRef);
    const amountOfPages = Math.ceil(filteredRefs.length / refsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);


    const SearchNameByInput = (input) => {
        const value = input.target.value;
        SetSearchValue(value);

        if (value === '') {
            SetFilteredRefs(allRefImages);
        } else {
            const filtered = allRefImages.filter(item =>
                item.fieldData.name.toLowerCase().includes(value.toLowerCase())
            );
            SetFilteredRefs(filtered);
            setCurrentPage(1); // Reset to the first page of sear
        }
    }


        return (
            <div>
                <div className={"flex-row mt-1 mb-1"}>
                    <button className={"mr-2"}>Search by name</button>
                    <input type={"text"} value={searchValue} onInput={(input) => SearchNameByInput(input)}/>
                </div>
                <button onClick={() => paginate(1)}
                        className={`m-2 p-1 border-2 border-green-600 rounded text-green-600 hover:text-white hover:bg-green-600 transition-colors duration-300`}
                >
                    First Page
                </button>
                <button onClick={() => paginate(amountOfPages)}
                        className={`m-2 p-1 border-2 border-green-600 rounded text-green-600 hover:text-white hover:bg-green-600 transition-colors duration-300`}
                >
                    Last Page
                </button>
                <button onClick={() => setShowImages(!showImages)}
                        className="m-2 p-1 border-2 border-green-600 rounded bg-green-500 text-white hover:bg-green-700 transition-colors duration-300">
                    {showImages ? "Hide References" : "Show References"}
                </button>
                <div className={showImages ? '' : 'hidden'}>
                    {!loading && (
                        <div
                            className={`grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-10 w-full`}>
                            {
                                currentRefs.map((ref) => (
                                    <SingleRefView
                                        key={ref.id}
                                        handleDelete={handleDelete}
                                        id={ref.id}
                                        reference={ref}
                                    />
                                ))
                            }
                        </div>
                    )}
                </div>
                <button onClick={() => paginate(currentPage - 1)}
                        className={`m-2 p-1 border-2 border-green-600 rounded text-green-600 hover:text-white hover:bg-green-600 transition-colors duration-300 ${currentPage === 1 ? 'hidden' : ''}`}>
                    <ChevronLeftIcon className="h-5 w-5"/>
                </button>
                <button onClick={() => paginate(currentPage + 1)}
                        className={`m-2 p-1 border-2 border-green-600 rounded text-green-600 hover:text-white hover:bg-green-600 transition-colors duration-300 ${currentPage === amountOfPages ? 'hidden' : ''}`}>
                    <ChevronRightIcon className="h-5 w-5"/>
                </button>
                <GoogleMapComponent allInstitutionNames={filteredRefs} ></GoogleMapComponent>
            </div> 
        );
}

export default AllRefListView;